import { Grid } from "@mui/material";
import React from "react";
import "../../assets/css/HeaderLogo/headerLogo.css";

const HeaderLogo = () => {
  return (
    <Grid container className="root">
      <Grid
        item
        xs={12}
        style={{
          // backgroundColor: "yellow",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div className="logo-header-discount-code">
          <a
            href={"https://www.legalfarm.it/"}
            style={{ textDecoration: "none" }}
          >
            <div className="logo-legal-farm-full-negative" />
          </a>
        </div>
      </Grid>
    </Grid>
  );
};

export default HeaderLogo;
